<div *ngIf="!showLoadingFlag" id="customer-eligibility-form">
  <form class="form" [formGroup]="customerEligibility">
    <div id="category-first-section" *ngIf="showCat">
      <div class="row">
        <div class="col-md-12">
          <div class="responder-dropdown">
            <h2 *ngIf="!isPSEAffcode">
              <strong>{{cfetLabels.cfet_customer_eligibility.select_category_desc}}</strong>
            </h2>
            <h2 *ngIf="isPSEAffcode">
              <strong>{{cfetLabels.cfet_customer_eligibility.select_category_desc_pse}}</strong>
            </h2>
          </div>
        </div>
      </div>
      <div class="row" id="row-dropdown">
        <div id="category" class="col-md-12">
          <label for="category">{{cfetLabels.cfet_customer_eligibility.category}}</label>
          <div class="field-group">
            <div [ngClass]="checkCategoryVal ? 'dropdown-opened' : ''">
              <abs-dropdown tabindex="0" [drId]="'select_category'" [drName]="'selectCategorydd'" [(dropdownValue)]="categoryValueDefault"
                formControlName="selectCategory" [optionRepeat]="categoryListArray"
                (dropdownValueChange)="onChangeCategory($event)" (click)="onClickCategory($event)" (keyup)="onClickCategory($event)" ngDefaultControl>
              </abs-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="role-second-section" *ngIf="showRoleBoolean">
      <div class="row">
        <div class="col-md-10 role-mobile">
          <div class="role-dropdown">
            <h2><strong>{{cfetLabels.cfet_customer_eligibility.select_role_desc}} <span
                  id="selected-category">{{selectedCat}}</span>{{cfetLabels.cfet_customer_eligibility.select_role_desc1}}</strong>
            </h2>
          </div>
        </div>
        <div class="col-md-2 icon-mobile">
          <em class="icon-misc-penL" role="img" aria-label="Edit Button" tabindex="0" (click)="editCategory($event)"
            (keyup)="editCategory($event)"></em>
        </div>
      </div>
      <div class="row" id="row-dropdown">
        <div id="role" class="col-md-12">
          <label for="role">{{cfetLabels.cfet_customer_eligibility.role}}</label>
          <div class="field-group">
            <div [ngClass]="checkRoleVal ? 'dropdown-opened' : ''">
              <abs-dropdown tabindex="0" [drId]="'select_role'" [drName]="'selectRoledd'" [(dropdownValue)]="roleVal"
                formControlName="selectRole" [optionRepeat]="roleListArray" (dropdownValueChange)="onChangeRole($event)"
                (click)="onClickRole($event)" (keyup)="onClickRole($event)" ngDefaultControl>
              </abs-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="role-confirm-section" *ngIf="showConfirmRoleFlag">
      <div class="row" *ngIf="!showSpinnerFlag">
        <div class="col-md-10 role-mobile-max">
          <div class="selected-role-dropdown">
            <label for="selected-role" class="selected-role-heading"><strong>{{selectedRoleVal}}</strong></label>
          </div>
        </div>
        <div class="col-md-2 role-mobile-styling">
          <em class="icon-misc-penL" role="img" aria-label="Edit Button" id="icon-role" tabindex="0"
            (click)="editRole($event)" (keyup)="editRole($event)" [ngClass]="{'icon-disabled': showIneligibilityFlag}"></em>
        </div>
      </div>
      <div *ngIf="!showSpinnerFlag" class="dividercomp section">
        <div class="row" id="action-divider"></div>
      </div>
      <div *ngIf="hideButtonsFlag">
        <div class="row" id="row-dropdown">
          <div class="col-md-12">
            <div class="row question-title-column " id="question-title-column">
              <div *ngFor="let row of selectedJobQuestions; let $index=index;" id="question-container{{$index}}"
                class="question-container">
                <div class="row first-initial-eligibility-column " id="first-initial-eligibility-column">
                  <div class="questionvalue">
                    <div id="select-question-{{$index}}" class="select-question-{{$index}} ">
                      <p><label for="questions" class="selected-role-ques ilm-note">{{row.questionValue}}</label></p>
                    </div>
                  </div>
                  <div id="yes-or-no-btn-{{$index}}" class="row yes-or-no-btn">
                    <div class="col-md-6 mobile-styling"
                      [ngClass]="(selectedconfirmVal[$index]==='Yes' && !showIneligibilityFlag) ? 'confirm-checkbox1' : ''">
                      <button class="confirm-btn" id="confirm-btn-yes-{{$index}}-0" tabindex="0"
                        (click)="roleConfirmYes($event,$index)" (keyup)="roleConfirmYes($event,$index)"
                        [disabled]="showIneligibilityFlag">{{cfetButtonLabels.button_labels.yes}}</button>
                    </div>
                    <div id="no-button-{{$index}}" class="col-md-6 no-button mobile-styling"
                      [ngClass]="(selectedconfirmVal[$index]==='No' && !showIneligibilityFlag) ? 'confirm-checkbox1' : ''">
                      <button class="confirm-btn" id="confirm-btn-no-{{$index}}-0" tabindex="0"
                        (click)="roleConfirmNo($event,$index)" (keyup)="roleConfirmNo($event,$index)"
                        [disabled]="showIneligibilityFlag">{{cfetButtonLabels.button_labels.no}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="note-from-ilm" class="note-from-ilm" *ngIf="showNote">
              <label for="note"><span
                  class="ilm-note">{{cfetLabels.cfet_customer_eligibility.note}}</span>{{messageNote}}</label>
            </div>
          </div>
        </div>
        <div class="row" id="confirm-checkbox" *ngIf="showConfirmCheckFlag">
          <div class="col-md-12">
            <label for="affirm-checkbox" class="checkbox">
              <input id="affirm-checkbox" tabindex="0" type="checkbox" (click)="confirmCheckbox($event)"
                (keyup)="confirmCheckbox($event)" [disabled]="showIneligibilityFlag" unchecked required />
              <em class="skin" tabindex="-1"></em>
              <span>
                <label for="affirm-checkbox"
                  class="checkboxContent">{{cfetLabels.cfet_customer_eligibility.affirm}}</label>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div id="ineligibility-section" *ngIf="showIneligibilityFlag">
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <div class="row">
          <div class="col-md-12" id="ineligibility-container">
            <app-customer-ineligibility></app-customer-ineligibility>
          </div>
        </div>
      </div>
      <div class="row" id="workplace-section" *ngIf="showWorkplaceFlag">
        <div class="col-md-12" id="workplace-container">
          <app-customer-eligibility-workplace (eligibilitycompletionstatus)="onEligibilityCompletion($event)"
            (editSelected)="onEditSelection($event)" (workplaceSelected)="hideWorkplaceFlagSection($event)"
            [showWorkplaceSection]="showWorkplaceSection" [showtickicon]="showtickicon"
            (stateAndZipPresent)="checkstateAndZip($event)" [stateAndZip]="stateAndZip"
            (manuallyAddedValues)="hideWorkplaceFlagSection($event)" (savedManualValues)="saveManualValues($event)"
            [manuallyEnteredValues]="manuallyEnteredValues" (showLoadingSpinner)="showLoadingFlagSpinner($event)"
            (showCancelModal)="displayCancelModal($event)">
          </app-customer-eligibility-workplace>
        </div>
      </div>
    </div>
  </form>
</div>
<app-custom-spinner *ngIf="showLoadingFlag"></app-custom-spinner>